import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';

const FormField = ({
  type,
  disabled,
  placeholder,
  componentClass,
  children,
  label,
  meta: {
    touched,
    error,
    warning,
  },
  input,
  rows,
  className,
}) =>
  <FormGroup
    validationState={classNames({
      error: touched && !!error,
    }) || null}
    className={className}
  >
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="input-wrapper">
      <div className="autosubmit-loader"></div>
      <FormControl
        {...input}
        componentClass={componentClass}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
      >
        {children}
      </FormControl>
    </div>
    <HelpBlock>
      {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </HelpBlock>
  </FormGroup>;

FormField.propTypes = {
  componentClass: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.shape({
    placeholder: PropTypes.string,
  }),
  children: PropTypes.arrayOf(PropTypes.node),
  meta: PropTypes.shape({
    touched: PropTypes.boolean,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  className: PropTypes.string,
};

export default FormField;
